import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
const data = {
  // Seats: {
  //   "PT-in-Musculoskeletal-Sciences": "6 Seats",
  //   "PT-in-Cardiovascular-&-Respiratory-Sciences": "2 Seats",
  //   "PT-in-Neuro-Sciences": "3 Seats",
  //   "PT-in-Community-Health-Sciences": "2 seats",
  // },
  Objective:
    "The curriculum is to train the students to excel in academic skills, evidence-based and ethical practice in all the areas of physiotherapy care.",

  Eligibility:
    "Bachelor's degree in Physiotherapy from a recognized university with a minimum of 50 % marks in Bachelor of Physiotherapy.",
  Specialities: [
    "Musculoskeletal Physiotherapy",
    "Cardiovascular & Respiratory Physiotherapy",
    "Neuro Physiotherapy",
    "Community Physiotherapy",
  ],
  Duartion: "2 years",
  "Examination,-Methodology-And-Results": [
    "Dissertation synopsis has to be submitted within 6 months from the date of admission.",
    "A completed dissertation has to be submitted before 9 months of the final examination.",
    "Compulsory minimum of 80% of attendance is required",
    "University exam will be conducted at the end of 3rd academic term and the result will be declared by MUHS, Nashik.",
    "Level of Passing – 50% and above in both theory and Practical",
  ],
  "Admission-Procedure":
    "Admission to BPTh course will be given as per the rules and regulations of Pravesh Niyantran Samiti, Mumbai, DMER, Mumbai and Maharashtra University of health sciences, Nashik.",
  "Fee-Structure":
    "The fees will be as directed by Shikshan Shulka Samiti of Govt of Maharashtra",
};

const Mpt = () => {
  const traverse_data = Object.entries(data);

  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        {traverse_data.map((elem, i) => (
          <Typography key={i} variant="body2" my={2} fontSize={16}>
            <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
              {elem[0].includes("-") ? (
                <>{elem[0].split("-").join(" ")}</>
              ) : (
                <>{elem[0]}</>
              )}
            </span>
            <>
              {typeof elem[1] === "string" ? (
                <>&nbsp;-&nbsp;{elem[1]}</>
              ) : (
                <TableContainer>
                  <Table sx={{ maxWidth: 650 }}>
                    <TableBody>
                      {Object.entries(elem[1]).map((tabs, i) => (
                        <TableRow key={i}>
                          <TableCell
                            align="left"
                            sx={{
                              color: "primary.main",
                              pr: { xs: 2, md: 8 },
                              fontSize: 14,
                            }}
                          >
                            {tabs[0].includes("-") ? (
                              <>{tabs[0].split("-").join(" ")}</>
                            ) : (
                              <>
                                {tabs[0] === i.toString() ? (
                                  <>{Number(tabs[0]) + 1}</>
                                ) : (
                                  <>{tabs[0]}</>
                                )}
                              </>
                            )}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{ color: "primary.main", fontSize: 14 }}
                          >
                            {tabs[1]}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          </Typography>
        ))}
        {/* <Typography variant="h4">Add-On Courses</Typography>
      <img
        src={mptCourse}
        width="100%"
        style={{ margin: "auto" }}
        alt="Mpt Additional Course"
      /> */}
      </Stack>
    </Box>
  );
};

export default Mpt;
